// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3EuRo","item":"PaymentsMobile_item__1ogrs","label":"PaymentsMobile_label__3bTXT","amount":"PaymentsMobile_amount__35SFa"};